<svelte:head>

    <title>Dashboard • Ämtler-Bon Admin</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Overview from "../components/screens/overview.svelte";

</script>

<SessionManager />

<section>

    <Overview />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        height: inherit;
        margin-left: 31vh;
    }

</style>
